import WORDPRESS_MODEL_QUERY from 'graphql/wordpressModel.query'
// import MODEL_QUERY from 'graphql/model.query'
// import BOARD_MENU_QUERY from 'graphql/boardMenu.query'
// import MODELS_QUERY from 'graphql/models.query'
// import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'
import uppercaseFirst from 'helpers/uppercaseFirst'
// import graphqlQuery from 'helpers/graphqlQuery'
import MODEL_QUERY from '../../../../../graphql/model.query'
import ModelPage from '../../../../../components/ModelPage'
import BOARD_MENU_QUERY from '../../../../../graphql/boardMenu.query'
import MODELS_QUERY from '../../../../../graphql/models.query'
import getSitesForStaticPaths from '../../../../../helpers/getSitesForStaticPaths'
import Layout from '../../../../../components/Layout'
import StateInitializer from '../../../../../components/StateInitializer'
import getGlobalSettings from '../../../../../helpers/getGlobalSettings'
import getSites from '../../../../../helpers/getSites'
import PropTypes from 'prop-types'
import { createApolloClient } from '../../../../../lib/createApolloClient'
import * as Sentry from '@sentry/nextjs'

// import Loading from 'components/Loading'

function BoardModelSlug(props) {
  const {
    globalSettings,
    sites,
    siteSlug,
    title,
    site,
    boardType,
    boardSlug,
    modelSlug,
  } = props

  return (
    <StateInitializer
      globalSettings={globalSettings}
      sites={sites}
      siteSlug={siteSlug}
    >
      <Layout>
        <ModelPage
          {...props}
          url={`/${site}/${boardType}/${boardSlug}/${modelSlug}`}
          title={`${title}${boardType ? ` | ${uppercaseFirst(boardType)}` : ''}`}
        />
      </Layout>
    </StateInitializer>
  )
}

BoardModelSlug.propTypes = {
  globalSettings: PropTypes.object.isRequired,
  sites: PropTypes.array.isRequired,
  siteSlug: PropTypes.string.isRequired,
  title: PropTypes.string,
  site: PropTypes.string.isRequired,
  boardType: PropTypes.string.isRequired,
  boardSlug: PropTypes.string.isRequired,
  modelSlug: PropTypes.string.isRequired,
}

export default BoardModelSlug

export async function getStaticProps({ params }) {
  const { site, modelSlug, boardType } = params

  if (site === '_next') {
    return { notFound: true }
  }

  const apolloClient = createApolloClient()

  const [
    globalSettings,
    sites,
    { data, error },
    { data: agencyPinData, error: agencyPinError },
  ] = await Promise.all([
    getGlobalSettings(site),
    getSites(),
    apolloClient
      .query({
        query: WORDPRESS_MODEL_QUERY,
        context: { site },
        variables: { site, modelUri: modelSlug, boardType },
      })
      .catch((e) => {
        return { data: null, error: e }
      }),
    apolloClient
      .query({
        query: MODEL_QUERY,
        context: { site: 'solarnet' },
        variables: { modelUri: modelSlug, boardType, site },
      })
      .catch((e) => {
        return { data: null, error: e }
      }),
  ]).catch((e) => {
    console.error(`Error loading Model props - ${e}`, { params })
    return [
      undefined,
      undefined,
      { data: null, error: e },
      { data: null, error: e },
    ]
  })

  if (error || agencyPinError) {
    if (error) {
      Sentry.addBreadcrumb({
        message: 'Error loading Model props from WordPress',
        data: { params, error },
        level: 'error',
      })
    }
    if (agencyPinError) {
      Sentry.addBreadcrumb({
        message: 'Error loading Model props from Agency Pin',
        data: { params, agencyPinError },
        level: 'error',
      })
    }

    Sentry.captureException(
      new Error('Error loading Model props from Agency Pin')
    )

    console.error(`Error loading Model props - ${error}`, { params })
    return { notFound: true, revalidate: 60 * 60 }
  }

  // The cover image should be the very first image in the gallery and not the model image!!
  const image =
    agencyPinData.model?.galleries[0]?.assets[0] ?? agencyPinData.model?.image

  const props = {
    ...params,
    ...data.modelBy,
    ...data.modelBy?.acfModel,
    bookers: data.modelBy?.acfModel?.bookers?.nodes ?? null,
    ...agencyPinData.model,
    image,
    globalSettings,
    sites,
    siteSlug: site,
  }

  return {
    props,
    revalidate: 60 * 60,
  }
}

export async function getStaticPaths() {
  const paths = []

  await getSitesForStaticPaths(
    ({ site }) => ({
      query: BOARD_MENU_QUERY,
      context: { site },
    }),
    async (data, { client, site }) =>
      Promise.all(
        data.modelBoards.nodes.map((parentBoard) =>
          Promise.all(
            (parentBoard.acfModelBoardParent.departmentOrder?.nodes || []).map(
              (subBoard) =>
                client
                  .query({
                    query: MODELS_QUERY,
                    context: { site: 'solarnet' },
                    variables: {
                      boardUri: subBoard.slug,
                      boardType: parentBoard.slug,
                      site,
                    },
                  })
                  .then(({ data }) =>
                    data.models.slice(0, 12).forEach((model) =>
                      paths.push({
                        params: {
                          site,
                          boardType: parentBoard.slug,
                          boardSlug: subBoard.slug,
                          modelSlug: model.slug,
                        },
                      })
                    )
                  )
            )
          )
        )
      )
  )

  return {
    paths,
    fallback: 'blocking',
  }
}
